<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("common.status") }}</h2>

    <div
      class="columns"
      v-if="storeBeingManaged.storeInfo.status !== 'showroom'"
    >
      <div class="column is-narrow">
        <b-select
          v-model="storeBeingManaged.storeInfo.status"
          placeholder="Status"
          @input="changeStoreStatus"
        >
          <option value="comingSoon">{{ $t("settings.comingSoon") }}</option>
          <option value="active">{{ $t("settings.active") }}</option>
          <option v-if="canSeeOnMaintenanceStatus" value="onMaintenance">
            {{ $t("settings.underMaintenance") }}
          </option>
        </b-select>
      </div>

      <div class="column">
        <p>
          <u>{{ $t("settings.comingSoon") }}</u>
          -
          {{ $t("settings.comingSoonExplanation") }}
        </p>

        <p>
          <u>{{ $t("settings.active") }}</u>
          -
          {{ $t("settings.activeExplanation") }}
        </p>

        <p v-if="canSeeOnMaintenanceStatus">
          <u>{{ $t("settings.underMaintenance") }}</u>
          -
          {{ $t("settings.underMaintenanceExplanation") }}
        </p>
      </div>
    </div>

    <p v-else>
      {{ $t("settings.showroom") }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "companyInfo"]),

    canSeeOnMaintenanceStatus() {
      return !["mq", "oniiFranchise"].includes(this.companyInfo.contract);
    }
  },

  methods: {
    changeStoreStatus() {
      this.isLoading = true;
      this.$store
        .dispatch("changeStoreStatus", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.storeInfo.status
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("settings.storeStatusUpdated"),
              type: "is-success",
              position: "is-bottom"
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.maintenance-switch {
  position: relative;
  top: 2px;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>
